// AppContext.js
import React, {
  createContext,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import moment from "moment";

// Create the context
export const AppContext = createContext();
// Create a provider component
export const AppProvider = ({ children }) => {
  // const storedUser = JSON.parse(localStorage.getItem("User")) ?? null;
  // const storedToken = localStorage.getItem("token") ?? null;
  //const lang = JSON.parse(localStorage.getItem("lang")) ?? null;
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");

  const [User, setUser] = useState(null); //storedUser
  const [Token, setToken] = useState(null); //storedToken
  const [Lang, setLang] = useState(lang);

  const user = JSON.parse(localStorage.getItem("User")) ?? null;

  const [OpenDrawer, setOpenDrawer] = useState(false);
  const [OpenDrawer2, setOpenDrawer2] = useState(false);

  const [ObjectData, setObjectData] = useState(false);

  const [AllApps, setAllApps] = useState("");

  const [Loading, setLoading] = useState(false);

  const [ChoosedDate, setChoosedDate] = useState(moment().format("DD-MM-YYYY"));
  const [ChoosedApps, setChoosedApps] = useState("");
  const [Services, setServices] = useState("");

  const [AllData, setAllData] = useState("");
  const [SelectedServices, setSelectedServices] = useState([]);

  const [step, setStep] = useState(1); // 1 = Select Services, 2 = Select Date & Time
  const [AppContextLoading, setAppContextLoading] = useState(true); // 👈 track loading
  const [phoneNumber, setPhoneNumber] = useState("");

  const [countryCode, setCountryCode] = useState("il");
  const [callingCode, setCallingCode] = useState("+972");
  const [userName, setUserName] = useState("");
  const [AppsBooked, setAppsBooked] = useState([]);
  const [OtherBarbers, setOtherBarbers] = useState([]);

  const [value, setValue] = useState(0);
  const [appointments, setAppointments] = useState([]);
  const [AllowUsersBookApp, setAllowUsersBookApp] = useState("");
  const [WazeData, setWazeData] = useState("");

  const removeUser = () => {
    try {
      localStorage.removeItem("User");
      setUser(null);
      console.log("✅ User removed!");
    } catch (e) {
      console.error("❌ Failed to remove user", e);
    }
  };

  useEffect(() => {
    //removeUser();
  }, []);
  return (
    <AppContext.Provider
      value={{
        User,
        setUser,
        OpenDrawer,
        setOpenDrawer,
        OpenDrawer2,
        setOpenDrawer2,
        ObjectData,
        setObjectData,
        setAllApps,
        AllApps,
        Loading,
        setLoading,
        ChoosedDate,
        setChoosedDate,
        ChoosedApps,
        setChoosedApps,
        Services,
        setServices,
        AllData,
        setAllData,
        SelectedServices,
        setSelectedServices,
        setStep,
        step,
        setAppContextLoading,
        AppContextLoading,
        setPhoneNumber,
        phoneNumber,
        setCountryCode,
        countryCode,
        setCallingCode,
        callingCode,
        setUserName,
        userName,
        AppsBooked,
        setAppsBooked,
        OtherBarbers,
        setOtherBarbers,
        setValue,
        value,
        setAppointments,
        appointments,
        AllowUsersBookApp,
        setAllowUsersBookApp,
        Lang,
        setLang,
        WazeData,
        setWazeData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export const useAppContext = () => useContext(AppContext);
